export interface Banner {
  _id: string;
  /** 推荐日期 */
  startTime: string;
  endTime: string;
  /** 调转链接h5 */
  jumpUrl: string;
  /** 小程序appid */
  appid: string;
  /** 小程序username */
  username: string;
  /** 图片详情 */
  imgUrl: string;
}

// 定义 ColumnLayout 类型
export interface ColumnLayout {
  columnType: ColumnType;
  bannerlist: Banner[];
}

/** banner的布局类型 */
export enum ColumnType {
  /** a:单个元素为一行布局,最大数为3 */
  a = 'a',
  /** b:三个元素为一行布局,只能为3 */
  b = 'b',
  /** c:两个元素为一行布局,元素数量只能为2的倍数,最大数6 */
  c = 'c',
  /** d:两个元素为一行布局或者三个元素为一行 */
  d = 'd',
}


export interface MultiJumpContainerType {
  /** bi上报标签 */
  biTag: string;
  /** 跳转链接h5 */
  jumpUrl: string;
  /** 小程序appid */
  appid: string;
  /** 小程序username */
  username: string;
  /** 图片详情 */
  imgUrl: string;
  /** 跳转链接小程序 */
  path: string;
}
